import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetPublishersLookups = () => {
  return useContentSelector(({ publishers }) => publishers.lookups);
};

export const useGetPublisherById = () => {
  return useContentSelector(({ publishers }) => publishers.getPublisherById);
};

export const useCreatePublisher = () => {
  return useContentSelector(({ publishers }) => publishers.createPublisher);
};

export const useEditPublisher = () => {
  return useContentSelector(({ publishers }) => publishers.editPublisher);
};

export const useSetContentEntityPublisher = () => {
  return useContentSelector(
    ({ publishers }) => publishers.setContentEntityPublisher
  );
};
